import { PrimaryTimberStorage } from "../../../types/models/TimberStorage";
import TimberStorageName from "./TimberStorageName";
import { timberStorageApi } from "../../../apis/TimberStorage.api.ts";
import {linkPath as linkPathParent} from "../../../../timber/components/cutting/CuttingDetail/CuttingLink";    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    const {data} = await dispatch(timberStorageApi.endpoints.getTimberStorage.initiate(PrimaryTimberStorage.fromId(id)))
    const prefix = await linkPathParent(dispatch, data.cuttingId)
    return `${prefix}/timber-storages/${PrimaryTimberStorage.fromId(id).toPath()}`
}

const TimberStorageLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <TimberStorageName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<TimberStorageName id={id}/>)
    else
        return undefined
}
export default TimberStorageLink;
